"use strict";
import StyleGuideColor from "./style_guide_color";
var StyleGuide = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "style-guide",
        style: { width: 1200, margin: "auto" }
      },
      /* @__PURE__ */ React.createElement("h1", null, "Style Guide"),
      /* @__PURE__ */ React.createElement("h2", null, "Colors"),
      /* @__PURE__ */ React.createElement("div", { className: "style-guide__colors" }, _.map(this.colors, this.showColor)),
      /* @__PURE__ */ React.createElement("h2", { style: { clear: "left" } }, "Buttons"),
      _.map(this.buttons, this.styleGuideButton)
    );
  },
  showColor: function(params) {
    return /* @__PURE__ */ React.createElement(StyleGuideColor, { name: params.name, description: params.description });
  },
  colors: [
    {
      name: "blackish",
      description: "Use this color instead of regular black, where possible"
    },
    {
      name: "dark-gray",
      description: "Dark Gray, used in Workboard labels, Queue bar and icons"
    },
    {
      name: "inactive-gray",
      description: "Inactive Gray. Primary color for indicating deactivated element states"
    },
    {
      name: "neutral-gray",
      description: "Warm-neutral gray, primarily used as a background tone against white"
    },
    {
      name: "near-white",
      description: "Near-white gray, primarily used as a background in the workboard area"
    },
    {
      name: "highlight",
      description: "Bright Blue. Used to highlight actionable areas, but not to either confirm or deny"
    },
    {
      name: "light-highlight",
      description: "Pastel 20% shade of the Bright Blue. Used as a less contrasting background"
    },
    {
      name: "caution",
      description: "Caution Orange-Red. Used sparingly to indicate errors, deletions and warnings"
    },
    {
      name: "light-caution",
      description: "Pastel 20% shade of the Caution Orange-Red. Used as a less contrasting background"
    },
    {
      name: "progress",
      description: "Hubtran Green. Used very sparingly to indicate a path to progress forward"
    },
    {
      name: "light-progress",
      description: "Pastel 20% shade of the Hubtran Green. Used as a less contrasting background"
    }
  ],
  buttons: [
    "button",
    "button--progress",
    "button--cancel",
    "button--selection",
    "button--confirmation",
    "button--caution"
  ],
  styleGuideButton: function(button) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { className: button }, ".", button));
  }
});
export default StyleGuide;
